export * from '@primeuix/themes/material/tabs';
export { default } from '@primeuix/themes/material/tabs';
